import type { ReactNode } from 'react';

export function Seccion({
  titulo,
  ayuda,
  ancho = '',
  children,
}: {
  titulo: string;
  ayuda: string;
  ancho?: string;
  children: ReactNode;
}) {
  return (
    <section className={`rounded-2xl border border-armazon-100 bg-white shadow-sm ${ancho}`}>
      <header className="px-5 pb-1 pt-4">
        <h2 className="text-sm font-bold uppercase tracking-tight text-armazon-800">{titulo}</h2>
        <p className="text-[11px] text-armazon-400">{ayuda}</p>
      </header>
      <div className="p-3 pt-2">{children}</div>
    </section>
  );
}
